// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__d3Sni","Brand":"header_Brand__oQBQI","User":"header_User__Xz0sq","Headerimg":"header_Headerimg__ohe60"};